<template>
  <div class="performance-early" :class="warnTitleCode !== 'MARKET_PERFORMANCE_WARN_004'?'warning-style':''">
    <!--    A-Z预警-->
    <template v-if="warnTitleCode === 'MARKET_PERFORMANCE_WARN_001'">
      <div class="early-margin-bottom">新增A-Z预警：<span>{{ data.dataLength }}条</span></div>
      <div class="early-margin-bottom">订单数：<span>{{ data.azClaimsTime | defaultShow }}</span></div>
      <div>订单缺陷百分比<span>></span><span class="percentage">{{ data.azClaims | defaultShow }}%</span></div>
    </template>

    <!--   Chargeback预警  -->
    <template v-else-if="warnTitleCode === 'MARKET_PERFORMANCE_WARN_002'">
      <div class="early-margin-bottom">订单数：<span>{{ data.chargebackTime | defaultShow }}</span></div>
      <div>信用卡拒付索赔<span>></span><span class="percentage">{{ data.chargeback | defaultShow }} %</span></div>
    </template>

    <!--    Return request预警-->
    <template v-else-if="warnTitleCode === 'MARKET_PERFORMANCE_WARN_003'">
      <div><span>绩效return request异常，负面反馈></span><span
          class="percentage">{{ data.negativeFeedBacks | defaultShow }} %</span></div>
    </template>

    <!--    客户服务绩效异常预警-->
    <template v-else-if="warnTitleCode === 'MARKET_PERFORMANCE_WARN_004'">
      <div class="serve-warning">
        <div class="flex border-bottom">
          <div class="flex-left">
            <div class="left-title">订单缺陷率</div>
            <div class="left-content"> > <span>{{ data.orderWithDefects | defaultShow }}</span> %</div>
          </div>
          <div class="flex-right">
            <dl class="flex margin-bottom">
              <dt>负面反馈>{{ data.negativeFeedBacks | defaultShow }} %</dt>
              <dd><span>{{ data.negativeFeedBacksTime }}</span>次</dd>
            </dl>
            <dl class="flex margin-bottom">
              <dt>A-Z>{{ data.azClaims | defaultShow }}%</dt>
              <dd><span>{{ data.azClaimsTime | defaultShow }}</span>次</dd>
            </dl>
            <dl class="flex">
              <dt>chargeback>{{ data.chargeback | defaultShow }}%</dt>
              <dd><span>{{ data.chargebackTime | defaultShow }}</span>次</dd>
            </dl>
          </div>
        </div>

        <div class="flex">
          <div class="flex-left">
            <div class="left-title">退货不满意率</div>
            <div class="left-content"> > <span>{{ data.returnDissatisfaction | defaultShow }}</span> %</div>
          </div>
          <div class="flex-right">
            <dl class="flex margin-bottom">
              <dt>负面回复>{{ data.negativeReturnFeedback | defaultShow }}%</dt>
              <dd><span>{{ data.negativeReturnFeedbackTime | defaultShow }}</span>次</dd>
            </dl>
            <dl class="flex margin-bottom">
              <dt>延迟回复>{{ data.lateResponse | defaultShow }}%</dt>
              <dd><span>{{ data.lateResponseTime | defaultShow }}</span>次</dd>
            </dl>
            <dl class="flex">
              <dt>无效拒绝>{{ data.invalidRejection | defaultShow }}%</dt>
              <dd><span>{{ data.invalidRejectionTime | defaultShow }}</span>次</dd>
            </dl>
          </div>
        </div>
      </div>
    </template>

    <!--    配送绩效异常预警-->
    <template v-else-if="warnTitleCode === 'MARKET_PERFORMANCE_WARN_006'">
      <div class="distribution">
        <div>迟发率>{{ data.lateShipment | defaultShow }}%，订单数： {{ data.lateShipmentOrder | defaultShow }}</div>
        <div>预配送取消率>{{ data.preFulfillmentCancellation | defaultShow }}%，订单数：
          {{ data.preFulfillmentCancellationOrder | defaultShow }}
        </div>
        <div>有效追踪率&lt;{{ data.validTracking | defaultShow }}%，订单数： {{ data.validTrackingOrder | defaultShow }}</div>
        <div>准时交货率&lt;{{ data.onTimeDelivery | defaultShow }}%，订单数： {{ data.onTimeDeliveryOrder | defaultShow }}</div>
      </div>
    </template>

    <!--    周销量暴涨或异常预警（店铺维度）-->
    <template v-else-if="warnTitleCode==='DATA_INDEX_WARN_001' || warnTitleCode === 'DATA_INDEX_WARN_003'">
      <div class="weekly-warp">
        <div>预警商品数量： <span class="warning-number">{{ data.warnQuantity | defaultShow }}</span>个</div>
        <div>上周销量： {{ data.saleLastWeek | defaultShow }}<span class="weekly-time">({{ data.saleLastWeekDay | defaultShow }})</span></div>
        <div>本周销量： {{ data.salesWeek | defaultShow }}<span class="weekly-time">({{ data.salesWeekDay | defaultShow }})</span></div>
        <div style="margin-bottom: 0" v-if="warnTitleCode==='DATA_INDEX_WARN_001'">周销量暴涨： {{ data.overAllRise | defaultShow }} %</div>
        <div style="margin-bottom: 0" v-else>周销量下跌： {{ data.overAllFall | defaultShow }} %</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "performance-early",
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    warnTitleCode: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped lang="scss">
.performance-early {
  line-height: 20px;
  font-size: 14px;
  color: #999;

  .early-margin-bottom {
    margin-bottom: 12px;
  }

  .serve-warning {
    padding: 0 18px;
    border: 1px solid #D8DADD;
    width: 350px;
    color: #333;

    > div.flex {
      padding: 18px 0;
    }

    .border-bottom {
      border-bottom: 1px solid #E0E2E7;
    }


    .flex-left {
      min-width: 120px;
      border-right: 1px solid #E0E2E7;
      text-align: center;
      padding-top: 12px;

      .left-title {
        margin-bottom: 8px;
        line-height: 20px;
        font-weight: 600;
      }

      .left-content {
        height: 34px;

        > span {
          color: #F5222D;
          font-size: 24px;
          font-weight: 600;
          line-height: 34px;
        }
      }
    }

    .flex-right {
      padding-left: 20px;
      line-height: 20px;
      width: 200px;

      .margin-bottom {
        margin-bottom: 8px;
      }

      dl {
        justify-content: space-between;
        margin: 0;
        width: 100%;

        dd {
          font-weight: 600;
          font-size: 12px;
          margin: 0;

          span {
            font-size: 16px;
            margin-right: 2px;
          }
        }
      }
    }
  }

  .distribution {
    color: #333;

    > div {
      margin-bottom: 12px;
    }

  }
}

.warning-style {
  span {
    color: #333;
    margin-left: 4px;
  }

  .percentage {
    color: #F5222D;
  }
}

.weekly-warp {
  color: #333;

  .warning-number{
    color: #F5222D ;
  }

  > div {
    margin-bottom: 8px;
    font-size: 14px;
  }

  .weekly-time {
    font-size: 12px;
    color: #666;
    margin-left: 30px;
  }
}
</style>
